import { FormattedDate } from "@edgetier/client-components";
import { FunctionComponent, memo } from "react";

import { IProps } from "./anomaly-date-filter-preview.types";
import "./anomaly-date-filter-preview.scss";

/**
 * Show selected date range.
 * @param props.endDateTime   Close date in the range.
 * @param props.startDateTime Opening date in the date.
 * @returns                   Formatted opening and closing dates.
 */
const AnomalyDateFilterPreview: FunctionComponent<IProps> = ({ startDateTime, endDateTime }) => {
    return (
        <div className="anomaly-date-filter-preview">
            <FormattedDate dateTime={startDateTime} /> &mdash; <FormattedDate dateTime={endDateTime} />
        </div>
    );
};

export default memo(AnomalyDateFilterPreview);
